/* global document */

import AppContext from './context/AppContext';
import React, { useCallback, useContext, useMemo } from 'react';
import '../styles/ContactUsHeader.css';
import constants from '../constants.json' assert { type: 'json' };



const ContactUsHeader = () => {
    const { appContext } = useContext(AppContext);

    const phoneNumber = useMemo(
        () => appContext.config.contactPhoneNumber,
        [ appContext.config.contactPhoneNumber ],
    );

    const handleClick = useCallback(() => {
        const {
            FORM_IFRAME_ID,
            BUTTON_IFRAME_ID,
            INPUT_SELECTOR,
            TEXTAREA_SELECTOR,
            BUTTON_SELECTOR,
        } = constants.ZENDESK;

        const zendeskFormIframe = document.querySelector(FORM_IFRAME_ID);
        const zendeskButtonIframe = document.querySelector(BUTTON_IFRAME_ID);

        if (zendeskFormIframe) {
            const inputs = zendeskFormIframe.contentDocument.querySelectorAll(`${INPUT_SELECTOR}, ${TEXTAREA_SELECTOR}`);
            for (const input of inputs) {
                if (!input.value) {
                    input.focus();
                    break;
                }
            }
        } else if (zendeskButtonIframe) {
            const zendeskButton = zendeskButtonIframe.contentDocument.querySelector(BUTTON_SELECTOR);
            const messageInput = zendeskButtonIframe.contentDocument.querySelector(INPUT_SELECTOR);

            if (messageInput) {
                messageInput.focus();
            } else if (zendeskButton) {
                zendeskButton.click();
            }
        }
    }, []);

    return (
        <div
            className={'contact-us-header'}>
            <span>
                Contact us toll free:
            </span>
            <a
                className={'custom-link'}
                href={`tel:${phoneNumber}`}
                style={{
                    fontStyle: 'italic',
                    fontWeight: '700',
                }}
            >
                {phoneNumber}
            </a>
            <span>or</span>
            <button
                onClick={handleClick}
                className={'contact-us-header--button'}
            >
                Chat Now
            </button>
        </div>
    );
};

export default ContactUsHeader;